import { Link } from 'react-router-dom';
import * as React from 'react';

import { LocalizedText } from '@shared-ui/localization-context';

export const ErrorLink = () => (
  <p className="error" data-stid="infosite-fetch-error">
    <LocalizedText message="hotels.infosite.errorMessage.text" />
    <Link to={'/Hotels'}>
      <LocalizedText message="hotels.infosite.tryAgain.text" />
    </Link>
  </p>
);
